<template>
    <div  >
        <div v-for="resource in collection" v-bind:key="resource.cardTimeId" class="list-row">
            <div class="list-columns">
                <div>
                    <custom-checkbox v-bind:ref="resource.refName" v-bind:id="resource.cardTimeId" v-bind:letter="firstLetter(resource.spent.toString())" v-on:change="selectItem(resource, $event)" v-bind:overrideColor="resource.color" ></custom-checkbox>
                </div>
                <div class="row-columns1 overflow100" >{{ resource.comment }}</div>
                <div class="row-columns1">{{ $moment(resource.date).format('DD-MM-YYYY') }}</div>
                <div class="row-columns1"> spent: {{ resource.spent }} remaining: {{ resource.remaining }}</div>
            </div>
            <div class="list-item-tools"> 
                <v-btn flat icon small  v-on:click="deleteEntry(resource.deleteHref)"><v-icon size="19px" color="#616161">delete</v-icon></v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import GenericRepository from "../../services/GenericRepository.js";
import HAL from "../../helpers/HAL.js";
import CustomCheckbox from "../primitive_componets/CustomCheckbox.vue";

export default {
    name: 'CardTimeListing',
    computed: {   
        
    },
    components: {
        CustomCheckbox
    },
    data(){
        return {
            collection: [],
            href: "",
            next: "",
            previous: "",
            selectedItems: [],
            isLoadingData: false,
            isInEditMode: false
        };
    },
    props: {
        listingLink: String
    },
    methods: {
         load() {
             if(!this.listingLink)
                return;
            this.collection = [];
             GenericRepository.getCollection(this.listingLink).then(response => {
                if(response.data.status == 'Success') {
                    let items = HAL.getEmbededResources(response.data, "help:card-time");
                    for (let i in items) {
                    items[i].refName = "cardtime_" + items[i].cardTimeId;
                    let deleteLink = HAL.getLink(items[i], "help:card-time-delete");

                    items[i].deleteHref = deleteLink ? deleteLink.href : null;
                    this.collection.push(items[i]);
                    }
                    this.next = HAL.getLink(response.data, "help:card-time", "Next");

                    if (items.length > 0) this.isLoadingData = false;
                }
             });
         },
         loadNext() {
            if(!this.next)
                return;
             GenericRepository.getCollection(this.next.href).then(response => {
                if(response.data.status == 'Success') {
                    let items = HAL.getEmbededResources(response.data, "help:card-time");
                    for (let i in items) {
                        items[i].refName = "cardtime_" + items[i].cardTimeId;
                        let deleteLink = HAL.getLink(items[i], "help:card-time-delete");

                        items[i].deleteHref = deleteLink ? deleteLink.href : null;
                        this.collection.push(items[i]);
                    }
                    this.next = HAL.getLink(response.data, "help:card-time", "Next");

                    if (items.length > 0) this.isLoadingData = false;
                }
             });
         },
         selectItem(item, value) {
            if (value) {
                this.selectedItems.push(item);
            } else {
                let index = this.selectedItems.indexOf(item);
                if (index != -1) {
                this.selectedItems.splice(index, 1);
                }
            }
        },
        firstLetter(a) {
            if (a && a.length > 0) {
                return a.charAt(0);
            }
            return "";
        },
        deleteEntry(link) {
            if (link) {
                if (confirm(this.$t("message.DeleteDialogMessage")) == true) {
                    GenericRepository.deleteEntity(link).then(
                        function(response) {
                        if (response.data.status == "Success") {
                            this.load();
                            this.$emit('timechanged', 'delete');
                        }
                        }.bind(this)
                    );
                }
            }
        }
    },
    created() {
        this.load();
    },
    watch: {
        listingLink(value) {
            if (!value) 
                return;
            this.load();
        }
    }
}
</script>

<style scoped>
.row-columns1 {
    padding: 0px 10px;
    white-space: nowrap;
}
.overflow100 {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 150px;
    white-space: nowrap;
}
</style>

